(function () {
    'use strict';

    angular
        .module('chilliAuth')
        .factory('loginInterceptor', LoginInterceptor);

    LoginInterceptor.$inject = ['$q', '$injector', 'store'];

    /**
     * HTTP interceptor to show login popup if user is not logged in.
     */
    function LoginInterceptor($q, $injector, store) {
        return {
            'request': function (config) {

                // Use $injector to get dependencies because circular dependencies are too easily made with HTTP interceptors.
                var chilliAuth = $injector.get('ChilliAuthService');

                if (!chilliAuth.isAuthenticated) {
                    return chilliAuth.showLogin().then(function () {
                        return config;
                    });
                } else {
                    return config;
                }
            },

            'responseError': function (rejection) {
                if (rejection.status === 401) {

                    // Use $injector to get dependencies because circular dependencies are too easily made with HTTP interceptors.
                    var chilliAuth = $injector.get('ChilliAuthService');
                    var $http = $injector.get('$http');

                    return chilliAuth.showLogin().then(function () {
                        // Retry now the user has logged in.
                        // Have to re-set the Authorization header with the new token.
                        rejection.config.headers.Authorization = 'bearer ' + store.get('token');
                        return $http(rejection.config);
                    });
                }

                return $q.reject(rejection);
            }
        };
    }
})();
